var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{class:[
    'text-area transition-input',
    _vm.disabled && 'disabled',
    _vm.error && 'error',
    _vm.value && 'filled',
    _vm.hasFocus && 'active',
  ],attrs:{"label":_vm.label,"label-for":_vm.id}},[_c('div',{staticClass:"position-relative fake-input"},[_c('b-form-textarea',{ref:"$input",staticClass:"text6",attrs:{"id":_vm.id,"placeholder":_vm.placeholder,"required":_vm.required,"disabled":_vm.disabled,"readonly":_vm.readonly,"rows":_vm.rows,"value":_vm.value,"autofocus":_vm.autofocus,"formatter":_vm.formatter},on:{"focus":_vm.onFocus,"input":_vm.onInput,"blur":_vm.onBlur}}),(_vm.maxLength)?_c('div',{staticClass:"text4 text-right"},[_vm._v(" "+_vm._s(_vm.length)+"/"+_vm._s(_vm.maxLength)+" ")]):_vm._e()],1),_c('InputError',{attrs:{"error":_vm.error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }